export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10115.7747a6b5.jpg";